import { createFileRoute } from '@tanstack/react-router';
import { JourneyTypeFormPage } from '@/components/journeys/JourneyTypeFormPage.tsx';
import { useRecordOrganisation } from '@/lib/recordOrganisation.ts';

export const Route = createFileRoute(
  '/_app/journey-types/organisations/$organisationId/$id',
)({
  staticData: { orgScope: 'record', orgScopeList: '/journey-types' },
  component: EditJourneyTypeRoute,
});

function EditJourneyTypeRoute() {
  const { organisationId, id } = Route.useParams();
  useRecordOrganisation(organisationId);

  return <JourneyTypeFormPage organisationId={organisationId} typeId={id} />;
}
